import { gql } from '@apollo/client';

/**
 * Guardian display-name gate.
 *
 * Phone-auth accounts have no name (Firebase `displayName` is null), so
 * after login we force the parent to enter one via `/name`. These two
 * documents back that flow:
 *   - CURRENT_GUARDIAN — is a name already set? (`displayName` null when not)
 *   - SET_GUARDIAN_DISPLAY_NAME — persist the entered name.
 *
 * NOTE: this app has no global <ApolloProvider>. Call these through the
 * shared `client` (client.query / client.mutate), NOT Apollo's
 * useQuery/useMutation — those throw "no client in context" here.
 */
export const CURRENT_GUARDIAN = gql`
  query {
    getCurrentUser {
      uid
      displayName
      phoneNumber
    }
  }
`;

export const SET_GUARDIAN_DISPLAY_NAME = gql`
  mutation SetGuardianDisplayName($name: String!) {
    setGuardianDisplayName(name: $name)
  }
`;
